/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LightbulbOnIcon16Light } from './LightbulbOnIcon16Light';
import { LightbulbOnIcon16Regular } from './LightbulbOnIcon16Regular';
import { LightbulbOnIcon16Solid } from './LightbulbOnIcon16Solid';
import { LightbulbOnIcon20Light } from './LightbulbOnIcon20Light';
import { LightbulbOnIcon20Regular } from './LightbulbOnIcon20Regular';
import { LightbulbOnIcon20Solid } from './LightbulbOnIcon20Solid';
import { LightbulbOnIcon24Regular } from './LightbulbOnIcon24Regular';
import { LightbulbOnIcon24Solid } from './LightbulbOnIcon24Solid';
import { LightbulbOnIcon32Regular } from './LightbulbOnIcon32Regular';
import { LightbulbOnIcon64Regular } from './LightbulbOnIcon64Regular';
var sizes = {
    16: {
        light: LightbulbOnIcon16Light,
        regular: LightbulbOnIcon16Regular,
        solid: LightbulbOnIcon16Solid,
    },
    20: {
        light: LightbulbOnIcon20Light,
        regular: LightbulbOnIcon20Regular,
        solid: LightbulbOnIcon20Solid,
    },
    24: {
        regular: LightbulbOnIcon24Regular,
        solid: LightbulbOnIcon24Solid,
    },
    32: {
        regular: LightbulbOnIcon32Regular,
    },
    64: {
        regular: LightbulbOnIcon64Regular,
    },
};
export var LightbulbOnIcon = forwardRef('LightbulbOnIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
